"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var withSitecoreContext_1 = require("../enhancers/withSitecoreContext");
var emittedVI = false;
var VIComponent = function (_a) {
  var sitecoreContext = _a.sitecoreContext;
  if (!emittedVI && typeof document !== 'undefined' && sitecoreContext.visitorIdentificationTimestamp) {
    emittedVI = true;
    var script = document.createElement('script');
    script.src = "/layouts/system/VisitorIdentification.js";
    script.type = 'text/javascript';
    document.getElementsByTagName('head')[0].appendChild(script);
    return react_1.default.createElement("meta", {
      name: "VIcurrentDateTime",
      content: sitecoreContext.visitorIdentificationTimestamp
    });
  }
  return null;
};
VIComponent.displayName = 'VisitorIdentification';
exports.VisitorIdentification = withSitecoreContext_1.withSitecoreContext()(VIComponent);